/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_BlockInputs */

const en_platform_plan_block = /** @type {(inputs: Platform_Plan_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength block`)
};

const pl_platform_plan_block = /** @type {(inputs: Platform_Plan_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blok siłowy`)
};

/**
* | output |
* | --- |
* | "Strength block" |
*
* @param {Platform_Plan_BlockInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_block = /** @type {((inputs?: Platform_Plan_BlockInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_BlockInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_block(inputs)
	return en_platform_plan_block(inputs)
});